// @flow
import React from 'react'
import { SequentialDatePicker } from 'src/components/SequentialDatePicker'
import { FormField, StyledField, Label, Error } from 'src/components/Form'
import type { DateField as DateFieldProps } from 'src/types'

const customStyles = {
  container: (base, state) => ({
    ...base,
    width: '100%',
    height: '100%',
    margin: '7px 0',
    border: 'none',
    outline: 'none',
    boxShadow: 'none',
    borderColor: 'none'
  }),
  control: (base, state) => ({
    ...base,
    width: '100%',
    height: '100%',
    borderRadius: '3px',
    fontSize: '16px',
    fontFamily: 'CircularStd',
    outline: 'none',
    backgroundColor: 'none',
    padding: '0 10px',
    border: 'none',
    boxShadow: 'none'
  }),
  placeholder: (base, state) => ({
    ...base,
    color: '#6e7b8c'
  }),
  singleValue: (base, state) => ({
    ...base,
    color: '#082622'
  }),
  indicatorSeparator: (base, state) => ({
    color: '#fff'
  }),
  menu: (base, state) => ({
    ...base,
    marginTop: '15px'
  }),
  group: (base, state) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '10px'
  }),
  option: (base, state) => ({
    ...base,
    color: '#6e7b8c',
    height: '100%',
    backgroundColor: '#fff',
    backgroundImage: state.isSelected ? 'linear-gradient(#f8f9fa, #f8f9fa)' : 'none'
  })
}

const renderSequentialDatePicker = ({
  className,
  input,
  label,
  type,
  options,
  components,
  placeholder,
  meta: { touched, error }
}: DateFieldProps) => (
  <FormField className={className}>
    <Label>{label}</Label>
    <StyledField hasError={touched && error}>
      <SequentialDatePicker
        {...input}
        styles={customStyles}
        value={input.value}
        onBlur={() => {}}
        placeholder={placeholder}
      />
      {touched && error && (
        <Error>Oh, you need to select {`${label}`.toLowerCase()} to continue</Error>
      )}
    </StyledField>
  </FormField>
)

export default renderSequentialDatePicker



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/SequentialDatePicker.js